<template>
<div class="chapter">
<div class="inner_page">
      ﻿


<title>The Monk Downstairs</title>
<link href="page-template.xpgt" rel="stylesheet" type="application/vnd.adobe-page-template+xml"/>
<link href="monkdownstairsthe.css" rel="stylesheet" type="text/css"/>
<meta content="application/xhtml+xml; charset=utf-8" http-equiv="content-type"/>
<div class="contents" id="TOC">
<h2 class="contentsHead" style="text-indent: 0%;">Contents</h2>
<div class="contentsEntry">
<p class="contentsEntryName"><a href="#/004epigraphpage#epigraphpage">Epigraph</a></p>
</div>
<div class="contentsEntry" id="part_01">
<p class="contentsEntryNumber1"><a href="#/006part01#part01">Part I</a></p>
</div>
<div class="contentsEntry" id="chapter_01">
<p class="contentsEntryNumber"><a href="#/007chapter01#chapter01">Chapter One</a></p>
<p class="contentsEntryName">Rebecca finally finished painting the in-law apartment on a Friday…</p>
</div>
<div class="contentsEntry" id="chapter_02">
<p class="contentsEntryNumber"><a href="#/008chapter02#chapter02">Chapter Two</a></p>
<p class="contentsEntryName">On Saturday morning Rebecca woke from a dream that she…</p>
</div>
<div class="contentsEntry" id="part_02">
<p class="contentsEntryNumber1"><a href="#/009part02#part02">Part II</a></p>
</div>
<div class="contentsEntry" id="chapter_03">
<p class="contentsEntryNumber"><a href="#/010chapter03#chapter03">Chapter Three</a></p>
<p class="contentsEntryName">The offices of Utopian Images were located five blocks south…</p>
</div>
<div class="contentsEntry" id="chapter_04">
<p class="contentsEntryNumber"><a href="#/011chapter04#chapter04">Chapter Four</a></p>
<p class="contentsEntryName">Saturday dawned unpromisingly, a low sky yielding grudging light. Rebecca…</p>
</div>
<div class="contentsEntry" id="part_03">
<p class="contentsEntryNumber1"><a href="#/012part03#part03">Part III</a></p>
</div>
<div class="contentsEntry" id="chapter_05">
<p class="contentsEntryNumber"><a href="#/013chapter05#chapter05">Chapter Five</a></p>
<p class="contentsEntryName">For weeks after the gathering at Stinson Beach, Rebecca didn’t…</p>
</div>
<div class="contentsEntry" id="chapter_06">
<p class="contentsEntryNumber"><a href="#/014chapter06#chapter06">Chapter Six</a></p>
<p class="contentsEntryName">Rebecca woke earlier than usual on Saturday morning, with a…</p>
</div>
<div class="contentsEntry" id="part_04">
<p class="contentsEntryNumber1"><a href="#/015part04#part04">Part IV</a></p>
</div>
<div class="contentsEntry" id="chapter_07">
<p class="contentsEntryNumber"><a href="#/016chapter07#chapter07">Chapter Seven</a></p>
<p class="contentsEntryName">They made love through the afternoon, something Rebecca had not…</p>
</div>
<div class="contentsEntry" id="chapter_08">
<p class="contentsEntryNumber"><a href="#/017chapter08#chapter08">Chapter Eight</a></p>
<p class="contentsEntryName">In the weeks after the fiasco with Michael Christopher, Rebecca…</p>
</div>
<div class="contentsEntry" id="chapter_09">
<p class="contentsEntryNumber"><a href="#/018chapter09#chapter09">Chapter Nine</a></p>
<p class="contentsEntryName">At work on Monday morning, a dress code had been…</p>
</div>
<div class="contentsEntry" id="part_05">
<p class="contentsEntryNumber1"><a href="#/019part05#part05">Part V</a></p>
</div>
<div class="contentsEntry" id="chapter_10">
<p class="contentsEntryNumber"><a href="#/020chapter10#chapter10">Chapter Ten</a></p>
<p class="contentsEntryName">At the hospital, despite the genuine urgency of the attendants,…</p>
</div>
<div class="contentsEntry" id="chapter_11">
<p class="contentsEntryNumber"><a href="#/021chapter11#chapter11">Chapter Eleven</a></p>
<p class="contentsEntryName">Friday passed uneventfully into Saturday at the hospital, and Rebecca…</p>
</div>
<div class="contentsEntry" id="part_06">
<p class="contentsEntryNumber1"><a href="#/022part06#part06">Part VI</a></p>
</div>
<div class="contentsEntry" id="chapter_12">
<p class="contentsEntryNumber"><a href="#/023chapter12#chapter12">Chapter Twelve</a></p>
<p class="contentsEntryName">Three days later, Rebecca and Mike drove out to Phoebe’s…</p>
</div>
<p class="spaceBreak"> </p>
<div class="contentsEntry1" id="backmatterpage_01">
<p class="contentsEntryName"><a href="#/024backmatterpage01#backmatterpage01">Plus:</a> Insights, Interviews, and More</p>
</div>
<div class="contentsEntry1" id="acknowledgment_page">
<p class="contentsEntryName"><a href="#/027acknowledgmentpage#acknowledgmentpage">Acknowledgments</a></p>
</div>
<div class="contentsEntry1" id="review_page">
<p class="contentsEntryName"><a href="#/028reviewpage#reviewpage">Praise</a></p>
</div>
<div class="contentsEntry1" id="adcard_page">
<p class="contentsEntryName"><a href="#/029adcardpage#adcardpage">Other Books by Tim Farrington</a></p>
</div>
<div class="contentsEntry1" id="copyright_page">
<p class="contentsEntryName"><a href="#/030copyrightpage#copyrightpage">Copyright</a></p>
</div>
<div class="contentsEntry1" id="aboutpublisher_page">
<p class="contentsEntryName"><a href="#/031aboutpublisherpage#aboutpublisherpage">About the Publisher</a></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 005-TOC.vue?12aa84b4